import * as THREE from "three";
import TweenMax from "gsap";

export class transferEffect {
    constructor ( opts, canvas, format, obj1, obj2 = null, obj3 = null ) {

        // if ( format === "video" ) console.time( "video time" );
        // if ( format === "image" ) console.time( "image time" );
        // shader code
        const vertex = `
            varying vec2 vUv;

            void main() {
                
                vUv = uv;

                gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
                
            }
        `;

        const fragment = `
            varying vec2 vUv;

            uniform sampler2D faceTexture;
            uniform sampler2D faceTexture2;
            uniform sampler2D disp;

            uniform float dispFactor;
            uniform float effectFactor;

            void main() {

                vec2 uv = vUv;

                vec4 disp = texture2D(disp, uv);

                vec2 distortedPosition = vec2(uv.x + dispFactor * (disp.r*effectFactor), uv.y);
                vec2 distortedPosition2 = vec2(uv.x - (1.0 - dispFactor) * (disp.r*effectFactor), uv.y);

                vec4 _texture = texture2D(faceTexture, distortedPosition);
                vec4 _texture2 = texture2D(faceTexture2, distortedPosition2);

                vec4 finalTexture = mix(_texture, _texture2, dispFactor);

                gl_FragColor = finalTexture;
            }
        `;

        // load options
        const parent = opts.parent || console.warn( "no parent" );
        const dispImage = opts.displacementImage || console.warn( "displacement image missing" );
        const intensity = opts.intensity - 0 || 1;
        const speed = opts.speed - 0 || 1.6;
        const easing = opts.easing || "expo.in";

        let nowItem = -1;
        let changing = false;
        let timer = null;
        let waiting = "";
        let sizes = { width: 0, height: 0 };
        let isVideo = format === "video";

        const mobileAndTabletcheck = () => {
            var check = false;
            ( function ( a ) { if ( /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test( a ) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test( a.substr( 0, 4 ) ) ) check = true; } )( navigator.userAgent || navigator.vendor || window.opera );
            return check;
        };

        const getRatio = () => {
            let objRatio = 0;
            if ( isVideo ) {
                if ( window.innerWidth <= 768 ) {
                    objRatio = 1080 / 1920;
                } else {
                    objRatio = 1920 / 1080;
                }
            } else {
                if ( window.innerWidth <= 800 ) {
                    objRatio = 1170 / 2532;
                } else {
                    objRatio = 5760 / 3240;
                }
            }
            return objRatio;
        };
        let objRatio = getRatio();


        // three.js initialization
        // create scene & camera
        const scene = new THREE.Scene();
        const camera = new THREE.OrthographicCamera(
            parent.offsetWidth / -2,
            parent.offsetWidth / 2,
            parent.offsetHeight / 2,
            parent.offsetHeight / -2,
            1,
            2
        );

        camera.position.z = 1;


        // create renderer for three.js to render objects
        const renderer = new THREE.WebGLRenderer( {
            antialias: false,
            canvas: canvas,
            powerPreference: 'high-performance'
        } );

        renderer.setPixelRatio( window.devicePixelRatio );
        renderer.setClearColor( 0xffffff, 0.0 );
        renderer.setSize( parent.offsetWidth, parent.offsetHeight );


        // initiate loader
        const loader = new THREE.TextureLoader();
        loader.crossOrigin = "";

        // load texture
        let texture1 = null;
        let texture2 = null;
        let texture3 = null;
        let disp = null;

        if ( isVideo ) {
            texture1 = loader.load( `${ process.env.BASE_URL }textures/loading.png` );
            texture2 = new THREE.VideoTexture( obj1 );
            obj1.play();
        } else {
            texture1 = loader.load( obj1.src );
            texture2 = loader.load( obj2.src );
            texture3 = loader.load( obj3.src );
        }

        disp = loader.load( `${ process.env.BASE_URL }textures/${ dispImage }` );
        disp.wrapS = THREE.RepeatWrapping;
        disp.wrapT = THREE.RepeatWrapping;

        texture1.magFilter = THREE.LinearFilter;
        texture1.minFilter = THREE.LinearFilter;
        texture2.magFilter = THREE.LinearFilter;
        texture2.minFilter = THREE.LinearFilter;

        texture1.anisotropy = renderer.capabilities.getMaxAnisotropy();
        texture2.anisotropy = renderer.capabilities.getMaxAnisotropy();


        if ( texture3 ) {
            texture3.minFilter = THREE.LinearFilter;
            texture3.magFilter = THREE.LinearFilter;
            texture3.anisotropy = renderer.capabilities.getMaxAnisotropy();
        }


        // make meterial and geometry and add into the scene
        const mat = new THREE.ShaderMaterial( {
            precision: "lowp",
            uniforms: {
                effectFactor: { type: "f", value: intensity },
                dispFactor: { type: "f", value: 0.0 },
                faceTexture: { type: "t", value: texture1 },
                faceTexture2: { type: "t", value: texture1 },
                disp: { type: "t", value: disp }
            },

            vertexShader: vertex,
            fragmentShader: fragment,
            transparent: true,
            opacity: 1.0
        } );

        const geometry = new THREE.PlaneBufferGeometry(
            parent.offsetWidth,
            parent.offsetHeight,
            1
        );
        const object = new THREE.Mesh( geometry, mat );
        scene.add( object );

        const setSize = () => {
            const width = parent.offsetHeight * objRatio;
            const height = parent.offsetWidth * ( 1 / objRatio );

            // if ( !isVideo && parent.offsetWidth / parent.offsetHeight < 0.462 ) {
            //     if ( width > parent.offsetWidth ) {
            //         sizes.width = parent.offsetWidth;
            //         sizes.height = height;
            //     }
            //     if ( height > parent.offsetHeight ) {
            //         sizes.width = width;
            //         sizes.height = parent.offsetHeight;
            //     }
            // } else {
            //     if ( width > parent.offsetWidth ) {
            //         sizes.width = width;
            //         sizes.height = parent.offsetHeight;
            //     }
            //     if ( height > parent.offsetHeight ) {
            //         sizes.width = parent.offsetWidth;
            //         sizes.height = height;
            //     }
            // }
            if ( width > parent.offsetWidth ) {
                sizes.width = width;
                sizes.height = parent.offsetHeight;
            }
            if ( height > parent.offsetHeight ) {
                sizes.width = parent.offsetWidth;
                sizes.height = height;
            }

            renderer.setSize( sizes.width, sizes.height );
        };
        setSize();


        // add animation by requestAnimationFrame and render three.js scene to client side
        const animate = () => {
            if ( ( !changing && !isVideo ) || ( isVideo && document.body.scrollTop > 2.5 * window.innerHeight ) ) return;
            requestAnimationFrame( animate );
            renderer.render( scene, camera );
            // if ( isVideo ) console.log( "video animating" );
            // if ( !isVideo ) console.log( "image animating" );
        };

        const handelChanging = ( index ) => {

            if ( changing || index === nowItem )
                return;

            let t1 = null;
            let t2 = null;
            changing = true;
            animate();

            switch ( index ) {

                case 0:
                    t2 = texture1;
                    break;
                case 1:
                    t2 = texture2;
                    break;
                case 2:
                    t2 = texture3;
                    break;
            }

            t1 = mat.uniforms.faceTexture2.value;

            if ( t1 && t2 ) {
                mat.uniforms.faceTexture = { type: "t", value: t1 };
                mat.uniforms.faceTexture2 = { type: "t", value: t2 };
                mat.uniforms.dispFactor.value = 0;
            }

            TweenMax.to( mat.uniforms.dispFactor, {
                value: 1,
                ease: easing,
                duration: speed
            } );

            // if ( format === "video" ) console.timeEnd( "video time" );
            // if ( format === "image" ) console.timeEnd( "image time" );

            timer = setTimeout( () => {
                nowItem = index;
                changing = false;

                if ( waiting !== "" ) {
                    handelChanging( waiting );
                    waiting = "";
                } else {
                    clearTimeout( timer );
                    timer = null;
                }
            }, speed * 1000 + 30 );
        };

        // set animation by TweenMax.js
        this.transition = ( index ) => {
            if ( changing ) {
                waiting = index;
            } else {
                handelChanging( index );
            }
        };
        this.startAnim = () => {
            // changing = true;
            animate();
        };
        // this.stopAnim = () => {
        //     changing = false;
        //     // animate();
        // };

        window.addEventListener( "resize", ( e ) => {
            const top = document.body.scrollTop;
            const height = window.innerHeight;
            if ( top < 2.5 * height || top > 6 * height ) {
                // console.log( top, "true" );
                objRatio = getRatio();
                setSize();
            } else {
                // console.log( top, "false" );
            }

        } );

        // this.transition( 0 );

    }
};
